// @flow

import * as ACTIONS from '../constants/actions';

export type EntityTagT = {
  id: string,
  organisation: string,
  targetCollection: 'locations',
  tagType: string,
  tagValue: string,
  createdById?: string,
  createdAt?: string,
  updatedAt?: string,
};

export type ReducerType = {
  byId: { [string]: EntityTagT },
  allIds: string[],
  loading: boolean,
  error: ?string,
};

const INITIAL_STATE: ReducerType = {
  byId: {},
  allIds: [],
  loading: false,
  error: null,
};

export default function entityTagsReducer(
  state: ReducerType = INITIAL_STATE,
  { type, payload }: { type: string, payload: any },
): ReducerType {
  switch (type) {
    case ACTIONS.FETCH_TAGS_REQUEST:
      return { ...state, loading: true, error: null };

    case ACTIONS.FETCH_TAGS_SUCCESS: {
      const list = Array.isArray(payload) ? payload : [];
      const byId = { ...state.byId };
      const allIds = [...state.allIds];
      list.forEach((t) => {
        if (!t || !t.id) return;
        byId[t.id] = t;
        if (!allIds.includes(t.id)) allIds.push(t.id);
      });
      return { byId, allIds, loading: false, error: null };
    }

    case ACTIONS.FETCH_TAGS_ERROR:
      return { ...state, loading: false, error: payload };

    case ACTIONS.CREATE_TAG_SUCCESS:
      if (!payload || !payload.id) return state;
      return {
        ...state,
        byId: { ...state.byId, [payload.id]: payload },
        allIds: state.allIds.includes(payload.id)
          ? state.allIds
          : [...state.allIds, payload.id],
      };

    case ACTIONS.UPDATE_TAG_SUCCESS:
      if (!payload || !payload.id) return state;
      return {
        ...state,
        byId: { ...state.byId, [payload.id]: payload },
      };

    case ACTIONS.DELETE_TAG_SUCCESS: {
      if (!payload || !payload.id) return state;
      const { [payload.id]: _removed, ...rest } = state.byId;
      return {
        ...state,
        byId: rest,
        allIds: state.allIds.filter((id) => id !== payload.id),
      };
    }

    default:
      return state;
  }
}
